export default __webpack_public_path__ + "static/media/6_VaultOfGems.3b5db17b.png";